import Vue from 'vue'

const extracts = {
  namespaced: true,
  state: {
    products : {items:[]},
    orders : {items:[]},
  },
  mutations: {
    FETCH_PRODUCTS (state, extracts) {
      state.products = extracts
    },
    FETCH_ORDERS (state, extracts) {
      state.orders = extracts
    }
  },
  actions: {
    async getExtracts ({commit}, payload) {
        try {
          let response = await Vue.axios.get(process.env.VUE_APP_API_URL + `shopify/list-extracts/${payload.type}?take=${payload.take}&skip=${payload.skip}&orderby=${payload.orderby}&desc=${payload.descending}`);
          switch(payload.type){
            case 'Products':
              commit('FETCH_PRODUCTS', response.data);
              break;
            case 'Orders':
              commit('FETCH_ORDERS', response.data);
              break;
          }
        }
        catch(error) {
            console.log(error.statusText);
        }
    }
  }
}

export default extracts
